const BASE_URL = 'https://musicplayer-api.onrender.com/'

export default BASE_URL